module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.72d2c62f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/dropdown-arrow.svg
// module id = 685
// module chunks = 0